// Universal links always arrive over HTTPS.
const UNIVERSAL_LINK_PROTOCOL = "https:";

/**
 * Converts a universal link URL into an in-app href for the router.
 *
 * Only the host is discarded. The query string and hash must survive because
 * links such as the magic-link wrapper (`/auth/signin/link/?l=...`) and
 * invitation links (`/provider-invite?token=...`) carry required state there,
 * often including other encoded URLs that contain their own hosts.
 *
 * Returns null for anything that is not an HTTPS URL. The app also registers
 * a custom URL scheme for Google sign-in, and a custom-scheme URL's pathname
 * can itself be an absolute URL (`scheme:https://example.org`), which the
 * router would treat as an external navigation.
 */
export function getDeepLinkHref(url: string): string | null {
  let parsedUrl: URL;
  try {
    parsedUrl = new URL(url);
  } catch {
    return null;
  }

  if (parsedUrl.protocol !== UNIVERSAL_LINK_PROTOCOL) {
    return null;
  }

  const { pathname, search, hash } = parsedUrl;
  return `${pathname}${search}${hash}`;
}
